import { Box, Typography } from "@mui/material";
import { calculateDistance } from "../../helper/distanceCalc";

function Station({ item, setNavigate, geolocation }) {
  return (
    <Box
      onClick={() => setNavigate(item)}
      key={item.id}
      className="flex items-center justify-between"
      sx={{
        padding: "20px 10px 20px 20px",
        borderLeft: "5px solid transparent",
        borderBottom: "1px solid var(--grey-4)",
        backgroundColor: "var(--white)",
        cursor: "pointer",
        transition: "all .3s",
        transitionProperty: "border-left-color, background-color",
        "&:hover": {
          borderLeft: "5px solid var(--primary)",
          backgroundColor: "var(--grey-4)",
          "& .arrow-forward-bg-color": {
            fill: "var(--primary)",
          },
          "& .arrow-forward-fg-color": {
            fill: "var(--white)",
          },
        },
      }}
    >
      <Box>
        {geolocation?.latitude !== 0 && geolocation?.longitude !== 0 && (
          <Box
            sx={{
              color: "var(--grey-2)",
              fontSize: "12px",
            }}
          >
            {calculateDistance(
              item.latitude,
              item.longitude,
              geolocation?.latitude,
              geolocation?.longitude
            )}
          </Box>
        )}

        <Box
          sx={{
            color: "var(--grey-1)",
            fontWeight: "bold",
            fontSize: "16px",
            padding: "5px 0px",
          }}
        >
          {item?.customFields?.raisonsociale}
        </Box>
        <Box
          sx={{
            color: "var(--grey-2)",
            fontSize: "14px",
            fontWeight: 400,
          }}
        >
          <Typography variant="body2">
            {item?.businessAddress?.line1}
          </Typography>
          <Typography variant="body2">
            {item?.businessAddress?.city}, {item?.businessAddress?.postalCode}
          </Typography>
          <Typography variant="body2">
            <a href={`tel:${item?.businessPhone}`}>{item?.businessPhone}</a>
          </Typography>
        </Box>
      </Box>
      <Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={25}
          height={25}
          viewBox="0 0 25 25"
          className="svg-arrow-forward"
          style={{ transition: "fill .3s" }}
        >
          <circle
            className="arrow-forward-bg-color"
            cx={12.5}
            cy={12.5}
            r={12.5}
            fill="transparent"
            style={{ transition: "fill .3s" }}
          />
          <path
            className="arrow-forward-fg-color"
            fill="var(--primary)"
            d="M10.137 6.957l-.056.055a1 1 0 0 0 0 1.414l4.065 4.074-4.065 4.074a1 1 0 0 0 0 1.414l.056.055a1 1 0 0 0 1.414 0l5.543-5.543-5.543-5.543a1 1 0 0 0-1.414 0z"
            style={{ transition: "fill .3s" }}
          />
        </svg>
      </Box>
    </Box>
  );
}

export default Station;
